import { useEffect } from 'react';
import { useField } from 'react-final-form';
import { useSelector } from 'react-redux';

import { useActions } from '../../../../../hooks/useActions';
import { srMembershipPlansPricesSelector } from '../../../../../store/redux-slices/pricing/securityResponse/selectors';
import { srLoadStandardPricing } from '../../../../../store/saga-slices/pricing/securityResponse';
import { getFormGroupPath } from '../../../../../utils/getFormGroupPath';
import { BasicSubscriptionFormFields } from '../../BasicSubscriptionForm/basicSubscriptionForm.models';

type UseSRSubscriptionPricingForm = {
  name?: string;
  isEditMode?: boolean;
};

export const useSRSubscriptionPricingForm = ({
  name,
  isEditMode,
}: UseSRSubscriptionPricingForm) => {
  const {
    input: { value: subscriptionType },
  } = useField(getFormGroupPath(name, BasicSubscriptionFormFields.ProductType));

  const membershipPlansPrices = useSelector(srMembershipPlansPricesSelector);
  const SRLoadStandardPricing = useActions(srLoadStandardPricing);

  useEffect(() => {
    if (subscriptionType) {
      SRLoadStandardPricing();
    }
  }, [subscriptionType, SRLoadStandardPricing]);

  return {
    membershipPlansPrices,
    subscriptionType,
  };
};
